(function () {
  'use strict';
  if (window.__rokishiPricePopupFix) return;
  window.__rokishiPricePopupFix = true;

  var active = null;
  function getSafeTop() {
    var bottom = 12;
    document.querySelectorAll('.aac-announcement-bar, .announcement-bar, header, .shopify-section-header').forEach(function(el) {
      var r = el.getBoundingClientRect();
      if (r.top <= 1 && r.bottom > bottom && r.bottom < window.innerHeight * 0.45) bottom = r.bottom + 12;
    });
    return bottom;
  }
  function closePopup(restoreFocus) {
    if (!active) return;
    var a = active;
    active = null;
    a.popup.classList.remove('is-open', 'rokishi-popup-portal');
    a.popup.setAttribute('aria-hidden', 'true');
    a.button.setAttribute('aria-expanded', 'false');
    a.popup.style.left = '';
    a.popup.style.top = '';
    if (a.placeholder.parentNode) a.placeholder.replaceWith(a.popup);
    if (restoreFocus && a.button.isConnected) a.button.focus({preventScroll:true});
  }
  function positionPopup() {
    if (!active) return;
    var p = active.popup;
    var r = active.button.getBoundingClientRect();
    var width = p.offsetWidth || 300;
    var height = p.offsetHeight || 180;
    var vw = document.documentElement.clientWidth;
    var vh = window.innerHeight;
    var safeTop = getSafeTop();
    var left = Math.max(12, Math.min(r.left + r.width / 2 - width / 2, vw - width - 12));
    var above = r.top - height - 10;
    var below = r.bottom + 10;
    var mobile = window.matchMedia('(max-width: 749px)').matches;
    var top = mobile && above >= safeTop ? above : below;
    if (top + height > vh - 12 && above >= safeTop) top = above;
    top = Math.max(safeTop, Math.min(top, Math.max(safeTop, vh - height - 12)));
    p.style.left = left + 'px';
    p.style.top = top + 'px';
  }
  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-mf-price-info]');
    if (button) {
      event.preventDefault();
      event.stopPropagation();
      if (active && active.button === button) { closePopup(true); return; }
      closePopup(false);
      var container = button.closest('.mf-price-design');
      var popup = container && container.querySelector('[data-mf-price-popup]');
      if (!popup) return;
      var placeholder = document.createComment('rokishi-price-popup-position');
      popup.parentNode.insertBefore(placeholder, popup);
      document.body.appendChild(popup);
      popup.classList.add('rokishi-popup-portal', 'is-open');
      popup.setAttribute('aria-hidden', 'false');
      button.setAttribute('aria-expanded', 'true');
      active = {button:button, popup:popup, placeholder:placeholder};
      positionPopup();
      return;
    }
    if (event.target.closest('[data-mf-price-close]')) {
      event.preventDefault();
      closePopup(true);
      return;
    }
    if (active && !event.target.closest('[data-mf-price-popup]')) closePopup(false);
  }, true);
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && active) { event.preventDefault(); closePopup(true); }
  });
  window.addEventListener('resize', function() { if (active) positionPopup(); }, {passive:true});
  window.addEventListener('scroll', function() { if (active) closePopup(false); }, {passive:true, capture:true});
})();
